import partnerLinksTriggerView from './partnerLinksTriggerComponent.html';
import './partnerLinksTriggerComponent.css';

export function partnerLinksTriggerComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		controller: partnerLinksTriggerComponentCtrl,
		template: partnerLinksTriggerView,
	};
}

export class partnerLinksTriggerComponentCtrl {
	constructor($timeout, PartnerLinks) {
		'ngInject';
		this.updateState = this.updateState.bind(this);
		this.$timeout = $timeout;
		this.PartnerLinks = PartnerLinks;
		this.PartnerLinks.onStateChange(this.updateState);
		this.state = {};
	}

	$onDestroy() {
		this.PartnerLinks.offStateChange(this.updateState);
	}

	toggleExpanded() {
		this.PartnerLinks.toggleExpanded();
	}

	updateState(state) {
		this.$timeout(() => {
			this.state = state;
		});
	}
}
